import React from "react";

import { ILocalizable, isLocalizable } from "infrastructure/localization";
import { useLocalizerWithFallback } from "ui/hooks";

export interface ILocalizableText {
  text: ILocalizable | string | undefined;
}

export const LocalizableText: React.FC<ILocalizableText> = ({ text }) => {
  const localizeWithFallback = useLocalizerWithFallback();

  if (isLocalizable(text)) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{localizeWithFallback(text)}</>;
  } else {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{text}</>;
  }
};
